// ============================================
// src/components/home/AboutSection.tsx
// ============================================
"use client";
import { Box, Container } from '@mui/material';
import AboutContent from './AboutContent';
import ImpactAreasGrid from './ImpactAreasGrid';
import MethodologiesSection from './MethodologiesSection';

interface AboutSectionProps {
  isVisible: boolean;
}

export default function AboutSection({ isVisible }: AboutSectionProps) {
  return (
    <Container
      maxWidth="xl" // Cambiado de "lg" a "xl" para más ancho
      sx={{
        p: { xs: 3, md: 4, lg: 5 }, // Más padding en pantallas grandes
        mt: 4,
        mb: 6,
        // Ancho máximo ajustado pero con márgenes
        maxWidth: { xs: '100%', md: '95%', lg: '90%', xl: '90%' },
        mx: 'auto',
      }}
    >
      {/* Contenido principal - Dos bloques separados */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'center',
        gap: { xs: 4, md: 8, lg: 12 }, // Más espacio entre bloques
        mb: 6,
      }}>
        <AboutContent isVisible={isVisible} />
      </Box>

      {/* Áreas de impacto */}
      <ImpactAreasGrid isVisible={isVisible} />

      {/* Metodologías y Tecnologías */}
      <MethodologiesSection isVisible={isVisible} />
    </Container>
  );
}



